/**
 * Framework-free state store.
 *
 * Snapshots are immutable and replaced wholesale, so any UI layer can treat
 * identity as the change signal (`shallowRef` in Vue, `useSyncExternalStore` in
 * React, a plain `subscribe` elsewhere) without the wrapper knowing about any
 * of them.
 */
export function createInitialState() {
    return {
        lifecycle: 'idle',
        playing: false,
        ended: false,
        stalled: false,
        currentTime: 0,
        duration: 0,
        bufferedEnd: 0,
        playbackRate: 1,
        angles: [],
        activeAngleId: null,
        qualities: [],
        activeQualityId: 'auto',
        audioTracks: [],
        activeAudioTrackId: null,
        subtitleTracks: [],
        activeSubtitleTrackId: null,
        chapterTracks: [],
        activeChapterTrackId: null,
        chapters: [],
        sleepTimer: null,
        isAudioOnly: false,
        live: false,
        thumbnailsReady: false,
        error: null,
    };
}
export class StateStore {
    state;
    listeners = new Set();
    constructor(initial = createInitialState()) {
        this.state = Object.freeze(initial);
    }
    getState() {
        return this.state;
    }
    /** Merge a patch. No-ops (and does not notify) when nothing changes. */
    setState(patch) {
        let changed = false;
        for (const key of Object.keys(patch)) {
            if (patch[key] !== this.state[key]) {
                changed = true;
                break;
            }
        }
        if (!changed)
            return;
        this.state = Object.freeze({ ...this.state, ...patch });
        for (const listener of [...this.listeners])
            listener(this.state);
    }
    /** Replace the whole snapshot (a new load). Always notifies. */
    reset(state) {
        this.state = Object.freeze(state);
        for (const listener of [...this.listeners])
            listener(this.state);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    clearListeners() {
        this.listeners.clear();
    }
}
//# sourceMappingURL=store.js.map